import React from 'react';
import './AuditChangeTable.css';

const AUDIT_FIELD_LABELS = {
  location_ids: 'Locations',
  device_name_ids: 'Device names',
  applies_to_all_locations: 'All locations',
  applies_to_all_device_names: 'All device names',
  is_active: 'Active',
  sort_order: 'Sort order',
};

function formatAuditFieldLabel(fieldName) {
  if (!fieldName) return '—';
  if (AUDIT_FIELD_LABELS[fieldName]) return AUDIT_FIELD_LABELS[fieldName];
  return String(fieldName)
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

function formatCellValue(value) {
  if (value === null || value === undefined || value === '') return '—';
  return String(value);
}

function AuditChangeTable({ changes = [], emptyText = 'No field changes.' }) {
  if (!changes.length) {
    return <p className="audit-change-empty">{emptyText}</p>;
  }

  return (
    <div className="audit-change-table">
      <table className="changes-table">
        <thead>
          <tr>
            <th>Field</th>
            <th>Before</th>
            <th>After</th>
          </tr>
        </thead>
        <tbody>
          {changes.map((c, idx) => (
            <tr key={`${c.field_name || 'field'}-${idx}`}>
              <td className="audit-change-field">{formatAuditFieldLabel(c.field_name)}</td>
              <td className="audit-change-before">{formatCellValue(c.old_value)}</td>
              <td className="audit-change-after">{formatCellValue(c.new_value)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default AuditChangeTable;
